module.exports = __webpack_public_path__ + "img/counter.88692be8.png";